import * as THREE from 'three';
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry';

export const createConvexMesh = (
  coordinates: [number, number, number][],
  material: THREE.Material
) => {
  try {
    const geometry = new ConvexGeometry(coordinates.map(point => new THREE.Vector3(...point)));
    return new THREE.Mesh(geometry, material);
  } catch {
    return null;
  }
};

export const createPointMeshes = (
  coordinates: [number, number, number][],
  material: THREE.Material
) => {
  return coordinates.map(([x, y, z]) => {
    const geometry = new THREE.SphereGeometry(0.05, 32, 32);
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(x, y, z);
    return mesh;
  });
};
